import React from "react";
import classnames from "classnames";
import { Glyphicon, Navbar } from "react-bootstrap";

import styles from "./Sidebar.scss";

class Sidebar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showSidebar: false
    };

    this.toogleSidebar = this.toogleSidebar.bind(this);
  }

  render() {
    return (
      <div className={styles.sidebarContainer}>
        <Navbar.Toggle>
          <div className={styles.hamburgerButton} onClick={this.toogleSidebar}>
            <Glyphicon glyph="menu-hamburger" />
          </div>
        </Navbar.Toggle>

        <div
          className={classnames(styles.sidebar, {
            [styles.displaySidebar]: this.state.showSidebar
          })}
        >
          <div className={styles.closeSidebarIcon}>
            <span onClick={this.toogleSidebar}>&times;</span>
          </div>
          <ul className={styles.sidebarMenu}>{this.redenderChildren()}</ul>
        </div>
      </div>
    );
  }

  redenderChildren() {
    return (
      this.props.children &&
      this.props.children.map((item, index) => {
        const component = (
          <div
            key={index}
            className={classnames(styles.sidebarMenuItem, {
              [styles.sidebarMenuItemButton]: this.props.buttonIndex === index
            })}
            onClick={() => this.toogleSidebar(item)}
          >
            {item}
          </div>
        );

        return item ? component : null;
      })
    );
  }

  toogleSidebar(item) {
    this.setState(prevState => {
      const shouldKeepSidebarOpen =
        _.get(item, "props.Modal") || _.get(item, "props.id") === "settings";

      return {
        showSidebar: shouldKeepSidebarOpen
          ? prevState.showSidebar
          : !prevState.showSidebar
      };
    });
  }
}

export default Sidebar;



// WEBPACK FOOTER //
// ./src/routes/common/header/sidebar/Sidebar.js